export default __webpack_public_path__ + "static/media/default-avatar.53da499e.jpg";